export let timeSpanFormatString = "RoEJDe";
export default {timeSpanFormatString};